import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAssets } from 'hooks';

import { Asset } from 'hooks/useAssets/useAssets.types';

import { DesktopAssetsDetails } from './DesktopAssetsDetails';

export const DesktopAssetsDetailsContainer = () => {
  const { id } = useParams<{ id: string }>();
  const { getAssetById, assets, getAssets } = useAssets();
  const [asset, setAsset] = useState<Asset | null>(null);

  useEffect(() => {
    getAssets();
  }, [getAssets]);

  useEffect(() => {
    setAsset(getAssetById(id) ?? null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assets, id]);

  return <DesktopAssetsDetails asset={asset} />;
};
